























































































import { Component, Vue } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
import { area, ParamsInfo } from '@/api/property/area'
import Pagination from '@/components/Pagination/index.vue'
import { CommonDataModule } from '@/store/modules/commonData'
import { areaType } from '@/utils/enum/enum'
import { propertyPerson } from '@/api/property/propertyPerson'

@Component({
  components: {
    Pagination
  }
})
export default class PropertyArea extends Vue {
  private paramsInfo: ParamsInfo = {
    name: '',
    wyOrganizationId: this.$Cookies.get('wyOrganizationId'),
    pageNum: 1,
    pageSize: 10
  }
  private groupId: any[] = []
  private areaList: any[] = []
  private areaTotal: number = 0
  private orgInfo: any[] = []
  private leaders: any[] = []
  private types: any[] = areaType
  private groups = []
  private dialogVisible: boolean = false
  private dialogTextType = ''
  private dialogInfo = {
    id: 0,
    name: '',
    isDisable: '',
    leader: [],
    building: '',
    layer: '',
    door: '',
    qrCode: '',
    groupId: '',
    type: []
  }
  private rules = {
    name: [{ required: true, message: '请输入区域名称', trigger: 'change' }],
    address: [{ required: true, message: '请将区域填写完整', trigger: 'change' }],
    // qrCode: [{ required: true, message: '请输入二维码信息', trigger: 'change' }],
    groupId: [{ required: true, message: '请选择组', trigger: 'change' }],
    type: [{ required: true, message: '请选择至少一个区域类型', trigger: 'change' }]
  }
  private async created() {
    this.orgInfo = await CommonDataModule.getOrganizations('property')
    this.groups = await CommonDataModule.getGroups()
    const response: any = await propertyPerson('GET', { wyOrganizationId: this.$Cookies.get('wyOrganizationId'), position: 0 }, null, '/PersonBase')
    this.leaders = response
    this.fetchData()
    this.queryTotal()
  }

  private async fetchData() {
    const response: any = await area('POST', this.paramsInfo, this.groupId, '/Page')
    this.areaList = response
  }
  private async queryTotal() {
    let params = Object.assign({}, this.paramsInfo)
    delete params.pageNum
    delete params.pageSize
    const response: any = await area('POST', params, this.groupId, '/Count')
    this.areaTotal = response
  }
  private async handleSearch() {
    this.paramsInfo.pageSize = 10
    this.paramsInfo.pageNum = 1
    this.fetchData()
    this.queryTotal()
  }

  private handleCreate() {
    this.dialogVisible = true
    this.dialogTextType = '新增区域'
    this.dialogInfo.qrCode = ''
    this.dialogInfo.building = ''
    this.dialogInfo.layer = ''
    this.dialogInfo.door = ''
    this.$nextTick(() => {
      (this.$refs.dataForm as ElForm).resetFields()
    })
  }
  private handleUpdate(rowData: any) {
    this.dialogVisible = true
    this.dialogTextType = '编辑区域'
    this.$nextTick(() => {
      (this.$refs.dataForm as ElForm).resetFields()
      this.dialogInfo = Object.assign({}, rowData)
    })
  }
  // 提交操作
  private submitCreateData() {
    (this.$refs.dataForm as ElForm).validate((valid: any) => {
      if (valid) {
        const submitData: any = Object.assign({}, this.dialogInfo)
        delete submitData.id
        area('POST', null, submitData).then( (response: any) => {
          this.fetchData()
          this.queryTotal()
          this.$message.success('新增区域成功')
          this.dialogVisible = false
        })
        .catch((err: any) => {
          this.$message.error(`${err}`)
        })
      }
    })
  }
  private submitUpdateData() {
    (this.$refs.dataForm as ElForm).validate((valid: any) => {
      if (valid) {
        area('PUT', null, this.dialogInfo).then( (response: any) => {
          this.fetchData()
          this.queryTotal()
          this.$message.success('编辑成功')
          this.dialogVisible = false
        })
      }
    })
  }
  // 删除
  private handleDetele(rowData: any) {
    this.$confirm(`此操作将把 ${rowData.name} 该区域移除, 是否继续?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      area('DELETE', null, [rowData.id]).then( (res: any) => {
        this.$message({ type: 'success',  message: '删除成功!' })
        this.fetchData()
        this.queryTotal()
      })
    }).catch(() => {
      this.$message({ type: 'info', message: '已取消删除' })
    });
  }
    // 停用、启用
  private handleDisable(rowData: any) {
    this.$confirm(`此操作将把 ${rowData.name} 该设备停用, 是否继续?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      rowData.isDisable = true,
      area('PUT', null, rowData).then( (res: any) => {
        this.$message({ type: 'success',  message: '停用成功!' })
        this.fetchData()
        this.queryTotal()
      })
    }).catch(() => {
      this.$message({ type: 'info', message: '已取消停用' })
    });
  }

  private handleRestore(rowData: any) {
    this.$confirm(`此操作将把 ${rowData.name} 该设备启用, 是否继续?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      rowData.isDisable = false,
      area('PUT', null, rowData).then( (res: any) => {
        this.$message({ type: 'success',  message: '启用成功!' })
        this.fetchData()
        this.queryTotal()
      })
    }).catch(() => {
      this.$message({ type: 'info', message: '已取消启用' })
    });
  }

  private stateFormat(row: any, column: any) {
    if (row.isDisable === false) {
      return '正常'
    } else  {
      return '停用'
    }
  }
}
